import React, { useEffect } from "react";
import Header from "components/Header/Header.js";
import HeaderLinks from "components/Header/HeaderLinks.js";
import Layout from "./Layout";
import UsersList from "./Sections/UsersList";

export default function UsersPage() {
	useEffect(() => {
		window.scrollTo(0, 0);
		document.body.scrollTop = 0;
		return function cleanup() {};
	}, []);

	return (
		<div>
			<Header
				color="info"
				brand="Auscomp Cloud Services"
				links={<HeaderLinks dropdownHoverColor="info" />}
				fixed
			/>
			<Layout>
				<UsersList />
			</Layout>
		</div>
	);
}
